// @see app/models/period_budget.rb
export const RESOURCE_COUNT_LIMIT = 30;
export const DAYS_LIMIT_FOR_DATE_RANGE_MODE = 62;
export const DAYS_LIMIT_FOR_DATE_SELECT_MODE = 30;

export { default } from './Form';
